let globalNavigate: ((path: string) => void) | null = null;

export const setGlobalNavigate = (navigateFn: (path: string) => void) => {
  globalNavigate = navigateFn;
};

export const navigateTo = (path: string) => {
  if (!globalNavigate) {
    console.warn("⚠️ Navigation not ready yet:", path);
    return;
  }

  globalNavigate(path);
};
